import api from './authService'

export interface FraccionArancelaria {
  codigo: string
  descripcion: string
  nivel: string
  padre_codigo?: string
  unidad_medida?: string
  arancel_imp?: string
  arancel_exp?: string
  nico?: string
}

export interface DetalleFraccion {
  detalle: FraccionArancelaria
  jerarquia: FraccionArancelaria[]
  hijos: FraccionArancelaria[]
}

export const ligieService = {
  /**
   * Busca fracciones arancelarias
   */
  async buscarFracciones(query: string, nivel?: string, padre?: string): Promise<FraccionArancelaria[]> {
    try {
      const params = new URLSearchParams()
      if (query) params.append('q', query)
      if (nivel) params.append('nivel', nivel)
      if (padre) params.append('padre', padre)

      const response = await api.get(`/api/ligie/fracciones?${params.toString()}`)
      return response.data
    } catch (error: any) {
      console.error('Error al buscar fracciones:', error)
      return []
    }
  },

  /**
   * Obtiene detalles de una fracción por su código
   */
  async obtenerDetalleFraccion(codigo: string): Promise<DetalleFraccion | null> {
    try {
      const response = await api.get(`/api/ligie/fracciones/${codigo}`)
      return response.data
    } catch (error: any) {
      console.error('Error al obtener detalle de fracción:', error)
      return null
    }
  }
}
